<div class="modal-header">
    <h6 class="modal-title" id="modal-title">{{ title }}</h6>
    <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>{{ prompt }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">
        <span cvLocalizedText langSection="Common" langKey="OK">Ok</span>
    </button>
</div>
